/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerRiskMatrix.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Risk Matrixes
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, January 21, 2019 - 05:31:24 AM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      01/21/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    RISKMATRIX_LIST_CONTAINER_LOADED,
    RISKMATRIX_LIST_CONTAINER_UNLOADED,
    RISKMATRIX_LIST_TABLE_LOADED,
    RISKMATRIX_LIST_TABLE_UNLOADED,

    RISKMATRIX_SELECT_ROW,
    RISKMATRIX_ADD,
    RISKMATRIX_EDIT,
    RISKMATRIX_DELETE,
    RISKMATRIX_OPEN_WARNING,
    RISKMATRIX_CLOSE_WARNING,

    RISKMATRIX_EDIT_CONTAINER_LOADED,
    RISKMATRIX_EDIT_CONTAINER_UNLOADED,
    RISKMATRIX_EDIT_FORM_LOADED,
    RISKMATRIX_EDIT_FORM_UNLOADED,
    RISKMATRIX_EDIT_DATA_LOAD,
    RISKMATRIX_EDIT_CONTAINER_SUBMIT,
    RISKMATRIX_EDIT_CONTAINER_CANCEL,

    RISKMATRIX_SET_CGROUP_SELECT,
    RISKMATRIX_SET_PGROUP_SELECT,
    RISKMATRIX_SET_RGROUP_SELECT
} from '../constants/actionTypeRiskMatrix';

const defaultState = {
    refreshList: false,
    danger: false,
    riskmatrixid: 0,
    consequenceid: 0,
    probabilityid: 0,
    riskclassid: 0
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case RISKMATRIX_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                riskmatrixes: action.payload[0] ? action.payload[0].records : null
            }
        case RISKMATRIX_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case RISKMATRIX_SELECT_ROW:
            return {
                ...state,
                riskmatrixid: action.id
            }
        case RISKMATRIX_ADD:
            return {
                ...state
            }
        case RISKMATRIX_EDIT:
            return {
                ...state,
                riskmatrixid: action.id
            }
        case RISKMATRIX_DELETE:
            return {
                ...state,
                riskmatrixid: null
            }
        case RISKMATRIX_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case RISKMATRIX_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case RISKMATRIX_EDIT_CONTAINER_LOADED:
        case RISKMATRIX_EDIT_DATA_LOAD:
            return {
                ...state,
                riskmatrixid: action.payload[0] ? action.payload[0].riskmatrixid : 0,
                consequenceid: action.payload[0] ? action.payload[0].consequenceid : 0,
                probabilityid: action.payload[0] ? action.payload[0].probabilityid : 0,
                riskclassid: action.payload[0] ? action.payload[0].riskclassid : 0
            }
        case RISKMATRIX_SET_CGROUP_SELECT:
            return {
                ...state,
                consequences: action.payload ? action.payload : []
            }
        case RISKMATRIX_SET_PGROUP_SELECT:
            return {
                ...state,
                probabilities: action.payload ? action.payload : []
            }
        case RISKMATRIX_SET_RGROUP_SELECT:
            return {
                ...state,
                riskclasses: action.payload ? action.payload : []
            }
        case RISKMATRIX_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case RISKMATRIX_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case RISKMATRIX_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case RISKMATRIX_LIST_CONTAINER_UNLOADED:
        case RISKMATRIX_LIST_TABLE_UNLOADED:
        case RISKMATRIX_EDIT_CONTAINER_UNLOADED:
        case RISKMATRIX_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerRiskMatrix.js